module.exports = __webpack_public_path__ + "static/img/estandarizada.ae1aa99e.png";